import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { compact, every, isEmpty, isString, trim } from 'lodash';

// tslint:disable-next-line:max-line-length
const EMAIL_REGEX = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  constructor() {}

  tokenizeEmails(emails: string): string[] {
    if (!emails) {
      return [];
    } else if (!isString(emails)) {
      throw new Error('tried to tokenize a non-string email');
    }

    return compact(emails.split(/[\s,;]+/));
  }

  validateEmails(emails: string, allowEmpty: boolean = false): boolean {
    const splitEmails = this.tokenizeEmails(emails);

    if (!allowEmpty && isEmpty(splitEmails)) {
      return false;
    }

    return every(splitEmails, (email) => this.isValidEmail(email));
  }

  isValidEmail(email: string, allowEmpty: boolean = false): boolean {
    if (!allowEmpty && isEmpty(email)) {
      return false;
    }

    return !!trim(email).match(EMAIL_REGEX);
  }

  emailValidatorFn(allowMultiple: boolean = true, allowEmpty: boolean = true) {
    return (formControl: FormControl): any => {
      const isValid = allowMultiple
        ? this.validateEmails(formControl.value, allowEmpty)
        : this.isValidEmail(formControl.value, allowEmpty);

      return isValid ? null : { email: { valid: false } };
    };
  }
}
